/**
 * M10 (retour Manon) — libellé de la semaine d'intervention montré à
 * l'HABITANT : « Intervention prévue la semaine du lundi 28 septembre ».
 * Le serveur n'envoie que le lundi (AAAA-MM-JJ) : ni jour exact, ni heure.
 */
export function libelleSemainePlanifiee(lundi: string | null | undefined): string | null {
  if (!lundi || !/^\d{4}-\d{2}-\d{2}$/.test(lundi)) return null;
  const [a, m, j] = lundi.split('-').map(Number);
  const d = new Date(Date.UTC(a!, m! - 1, j!));
  const txt = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  return `Intervention prévue la semaine du ${txt}`;
}
